import Container from '../Container';
import Field from '../Field';
import AnttButton from '../Button';
import React from 'react';

interface Props {
  consultar?: any;
  limpar: any;
  permissaoConsultar: any
}

export default function ConsultaButtons(props: Props) {
  return (
    <>
      <Field col={2}>
        <AnttButton
          permissao={props.permissaoConsultar}
          type="submit"
          label="Consultar"
          icon="pi pi-search"/>
      </Field>
      <Field col={2}>
        <AnttButton
          permissao={props.permissaoConsultar}
          icon="pi pi-times"
          type={'button'}
          className="p-button-secondary"
          label="Limpar"
          onClick={() => props.limpar()}
        />
      </Field>
    </>
  );
}
